import {CancelOrderRequest} from './DTO';
import {
    AssetType,
    DebitCredit,
    OrderAction,
    OrderClass,
    OrderDuration,
    OrderStatus,
    OrderType,
    PositionEffect,
} from './types';

export class Order {

    public static canHavePrice(order: Order): boolean {
        return (order.OrderType === 2 || order.OrderType === 4);
    }

    public static canHaveStop(order: Order): boolean {
        return (order.OrderType === 3 || order.OrderType === 4);
    }

    public static isChangeable(order: Order) {
        return order.OrderStatus === OrderStatus.New ||
            order.OrderStatus === OrderStatus.Replaced;
    }

    public static isWorking(order: Order) {
        const working = [OrderStatus.New, OrderStatus.Replaced,
            OrderStatus.PendingNew, OrderStatus.PendingReplace,
            OrderStatus.ReplaceInitiated, OrderStatus.Initiated,
        ];

        return working.findIndex((el) =>
            el === order.OrderStatus,
        ) > -1;
    }

    public static makeDayStockBuyLimit(symbol: string, quantity: number, limit: number): Order {
        const order = new Order();
        order.OrderClass = OrderClass.Single;
        order.Price = limit;
        order.UnderlyingSymbol = symbol;
        order.Legs = [{
            Action: OrderAction.Buy,
            PositionEffect: PositionEffect.Open,
            Symbol: symbol,
            SpreadRatio: null,
            AssetType: AssetType.Entity,
          }];
        order.Quantity = quantity;
        order.DebitCredit = DebitCredit.Debit;
        order.Duration = OrderDuration.Day;
        order.OrderType = OrderType.Limit;
        return order;
    }

    public static makeTradeOrder(src: Order): Order {
        const order: Order = new Order();

        order.Quantity = 0;
        order.AccountId = src.AccountId;
        order.SubaccountId = src.SubaccountId;
        order.OrderClass = src.OrderClass;
        order.Price = src.Price;
        order.Stop = src.Stop;
        order.OrderType = OrderType.Limit;
        order.UnderlyingSymbol = src.UnderlyingSymbol;
        if (src.OrderClass === 1) {
            order.Legs = [{
                Action: src.Legs[0].Action,
                PositionEffect: src.Legs[0].PositionEffect,
                Symbol: src.Legs[0].Symbol,
                SpreadRatio: null,
                AssetType: src.Legs[0].AssetType,
            }];

        } else {
            order.Legs = [{
                Action: src.Legs[0].Action,
                PositionEffect: src.Legs[0].PositionEffect,
                Symbol: src.Legs[0].Symbol,
                SpreadRatio: 1,
                AssetType: src.Legs[0].AssetType,
            }, {
                Action: src.Legs[1].Action,
                PositionEffect: src.Legs[1].PositionEffect,
                Symbol: src.Legs[1].Symbol,
                SpreadRatio: 1,
                AssetType: src.Legs[1].AssetType,
            }];
        }
        order.DebitCredit = src.DebitCredit;
        order.OrderType = OrderType.Market;
        order.Duration = OrderDuration.GTC;
        order.fixed = false;
        return order;
    }

    public static makeCancelRequest(src: Order) {
        return {
            OrderId: src.OrderId,
            SubaccountId: src.SubaccountId,
            AccountId: src.AccountId,
        } as CancelOrderRequest;
    }

    public static reset(order: Order) {
        order.AllOrNone = false;
        order.Quantity = 0;
        order.Duration = OrderDuration.Day;

        order.Price = 0;

        order.Stop = 0;

        order.Legs[0].Action = OrderAction.Buy;
        order.Legs[0].PositionEffect = PositionEffect.Open;
        order.OrderType = OrderType.Limit;
        /* delete order.OrderId;
        delete order.Date;
        delete order.Description;
        delete order.OrderStatus; */

        if (order.OrderClass === OrderClass.Spread) {
            order.Legs[0].SpreadRatio = 1;
            order.Legs[1].SpreadRatio = 1;
        } else {
            order.Legs[0].SpreadRatio = null;
        }

        if (order.Legs[1]) {

            order.Legs[1].AssetType = AssetType.Option;
            order.Legs[1].Action = OrderAction.Unknown;
            order.Legs[1].AssetType = AssetType.Option;
        }

    }

    public fixed?: boolean;

    public AccountId: number;
    public SubaccountId: number;
    public Date: string | Date;
    public OrderId: number;
    public Description: string;
    public DebitCredit: DebitCredit;
    public Quantity: number;
    public FillQuantity: number;
    public AllOrNone: boolean;
    public Legs: OrderLeg[] = [new OrderLeg()];

    public OrderClass: OrderClass = OrderClass.Single;

    public OrderStatus: OrderStatus;
    public OrderType: OrderType = OrderType.Market;

    public Price?: number | null = null;
    public Stop: number | null = null;
    public UnderlyingSymbol: string;
    public Duration: OrderDuration = OrderDuration.Day;

}

export class TableOrder extends Order {
    public editing: boolean = false;
}

export class OrderLeg {
    public SpreadRatio: number | null = 0;
    public Action: OrderAction = OrderAction.Buy;
    public Symbol: string = '';
    public PositionEffect: PositionEffect = PositionEffect.Open;
    public AssetType: AssetType = AssetType.Undefined;
}

